<script lang="ts">
    import { onMount, setContext } from 'svelte';
    const gigyaReadyEvent = 'gigya-ready';
    const { children } = $props<{}>();

    let gigyaContext = $state({
        ready: window.gigya.isReady,
        loggedIn: false
    });
    setContext('gigya', gigyaContext);

    function onGigyaServiceReady() {
        gigyaContext.ready = true;

        gigya.hasSession().then((hasSession: boolean) => {
            gigyaContext.loggedIn = hasSession;
        });

        gigya.accounts.addEventHandlers({
            onLogin: () => {
                gigyaContext.loggedIn = true;
            },
            onLogout: () => {
                gigyaContext.loggedIn = false;
            }
        });
    }

    onMount(() => {
        document.addEventListener(gigyaReadyEvent, onGigyaServiceReady);
        return () => {
            document.removeEventListener(gigyaReadyEvent, onGigyaServiceReady);
        }
    })
</script>

<!-- <svelte:head>
    <script>
        var onGigyaServiceReady = () => {
            const event = new CustomEvent('gigya-ready');
            document.dispatchEvent(event);
        }
    </script>
</svelte:head> -->


{@render children?.()}